import { combineReducers } from 'redux';
import { carPolicyRenewalReducer } from './CarPolicyRenewal';

export default combineReducers({
  carPolicyRenewalReducer,
});
